'use client'

import Link from 'next/link'
import React, { type ReactElement } from 'react'
import { useAtomValue } from 'jotai'
import { tenantAtom } from '@/store/global'

function Branding(): ReactElement {
  const tenant = useAtomValue(tenantAtom)
  return (
    <figure className="flex flex-row items-center gap-2 p-0 m-0">
      <svg
        fill="none"
        height={24}
        viewBox="0 0 48 48"
        width={24}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M37.2 11.2c-.5 0-1.7 1.5-2.3 2.2-1.6 2-4.1 5-7.9 4.2s-4.8-4.6-5.4-7.1c-.2-.9-.7-2.8-1.1-3L21.7 2c3.8.8 4.8 4.6 5.4 7.1.2.9.7 2.8 1.1 3 .5 0 1.7-1.5 2.3-2.2 1.6-2 4.1-5 7.9-4.2z"
          fill="#77AD54"
        />
        <path
          d="M43 40.2c-.5-.2-1.4-1.9-1.9-2.9-1.3-2.6-3.2-6.4-7.5-6.4s-6.3 3.9-7.5 6.4c-.5.9-1.4 2.8-2 3-.5-.2-1.5-2.1-1.9-3-1.3-2.6-3.2-6.4-7.6-6.4-4.3 0-6.3 3.9-7.6 6.4-.5.9-1.4 2.7-2 2.9v6.4c4.3 0 6.3-3.9 7.6-6.4.5-.9 1.4-2.8 2-3 .5.2 1.5 2.1 1.9 3 1.3 2.6 3.2 6.4 7.6 6.4 4.3 0 6.3-3.9 7.6-6.4.5-.9 1.4-2.8 2-3 .5.2 1.5 2.1 1.9 3 1.3 2.6 3.2 6.4 7.5 6.4v-6.4z"
          fill="#175D71"
        />
      </svg>
      <figcaption>
        <Link href="/" className="flex gap-1 text-base font-semibold text-nowrap truncate">
          <span className="hidden sm:inline font-bold">OREME</span>
          <span className="hidden sm:inline font-light text-border">/</span>
          {tenant ? <span className="font-light">{tenant.name}</span> : null}
        </Link>
      </figcaption>
    </figure>
  )
}

export { Branding }
